import React from 'react';
import PropTypes from 'prop-types';
import FollowThemes from '@/components/FollowThemes';
import { track } from '@bnnvara/analytics/src/track';
import * as S from './styled';
import FollowBrand from '../FollowBrand';
import HubLogo from './HubLogo';

const HubBody = ({ mobileHide, data }) => {
  const { __typename, name, description, slug } = data;
  const url = __typename === 'Theme' ? `/thema/${slug}` : `/${slug}`;
  let descriptionClass = mobileHide ? 'hide-mobile' : '';

  if (!data.logoUrl) {
    descriptionClass += ' no-image';
  }
  return (
    <S.HubBody>
      <S.BrandContainer>
        <HubLogo data={data} />
        <S.TitleWrapper>
          <S.BrandTitle
            tabIndex="0"
            href={url}
            onClick={() => {
              track('page', 'click', `${__typename.toLowerCase()}-hub-${name}`);
            }}
            aria-label={`Link naar de home van ${name}`}
          >
            {name}
          </S.BrandTitle>
        </S.TitleWrapper>
        {__typename === 'Brand' && <FollowBrand brand={data} />}
        {__typename === 'Theme' && <FollowThemes theme={data} />}
      </S.BrandContainer>
      <S.BrandDescription id="brandHubDescription" className={descriptionClass}>
        {description}
      </S.BrandDescription>
    </S.HubBody>
  );
};

HubBody.defaultProps = {
  mobileHide: false,
};

HubBody.propTypes = {
  mobileHide: PropTypes.bool,
  data: PropTypes.shape({
    __typename: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
  }),
};

export default HubBody;
